module.exports = __webpack_public_path__ + "static/media/20170503-DSC02707-2_Small.8f4f90e8.jpg";